import { render, staticRenderFns } from "./addModel.vue?vue&type=template&id=2e7537bf&"
import script from "./addModel.vue?vue&type=script&lang=js&"
export * from "./addModel.vue?vue&type=script&lang=js&"
import style0 from "./addModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports